// import required libraries
import $ from 'jquery';

// import components that run on every page
import Header from './components/Header';
import renderCastMembers from './actions/renderCastMembers';
import imageSlider from './components/ImageSlider';
import DottedLine from './components/DottedLine';

// Import Pages
import accessibility from './actions/accessibility';

// call functions
accessibility();
Header($);
renderCastMembers();
DottedLine($);

const sliders = document.querySelectorAll(".image-slider");

sliders.forEach((slider, index) => {
	imageSlider(slider, index);
})